/**
 * PaperFormSection — uppercase tracking-wider section label + content block
 * with optional Stack wrapper. Used for top-level groupings on a paper form.
 */

import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { SECTION_LABEL, FIELD_HINT } from "./styles";

export default function PaperFormSection({
  label,
  hint,           // optional sub-label hint, rendered in muted style
  children,
  spacing = 2,    // gap between Stack children when wrapped
  asStack = true, // when true, children are wrapped in <Stack>
  sx,
}) {
  const content = asStack ? <Stack spacing={spacing}>{children}</Stack> : children;
  return (
    <Box sx={sx}>
      {label && (
        <Typography sx={SECTION_LABEL}>
          {label}
          {hint && (
            <Typography component="span" sx={FIELD_HINT}>
              · {hint}
            </Typography>
          )}
        </Typography>
      )}
      {content}
    </Box>
  );
}
